import { Button } from "@/components/button";
import { useDesignMaxTheme } from "@/packages";
import { FONT } from "@/styles";
import { Box, Center, chakra, Text } from "@chakra-ui/react";
import { HEADER_GROUP, useBookingRecoilValue, useNewNavigate, useToggleValue } from "@shared/client";
import { motion } from "framer-motion";
import { type GlobalNavBarProps } from "./globalNavBar.type";

export const GlobalNavBar = ({ navigation }: GlobalNavBarProps) => {
    const isMenu = useToggleValue();
    const { onNavigate } = useNewNavigate();
    const bookingEngine = useBookingRecoilValue();
    const { COLORS, MEDIAS } = useDesignMaxTheme();
    const { isMobile } = MEDIAS();

    return (
        <Center
            columnGap="80px"
            sx={{
                "& > button": {
                    ...FONT("pretendard", 16, 300),
                    w: isMobile ? "64px" : "128px",
                    h: isMobile ? "32px" : "48px",
                    color: COLORS.white,
                    borderColor: COLORS.white,
                    background: "whiteAlpha.400",
                    _hover: {
                        background: "whiteAlpha.800",
                    },
                },
            }}
        >
            <MotionTitleBox
                display="none"
                columnGap="32px"
                initial={{ x: 0 }}
                animate={
                    isMenu
                        ? { x: "100vw", transition: { duration: 0.2, ease: "easeOut" } }
                        : { x: 0, transition: { duration: 0.2, ease: "easeOut" } }
                }
            >
                {HEADER_GROUP.map((menu) => {
                    return (
                        <Box key={menu.title} position="relative" cursor="pointer">
                            <Text
                                p="0 12px"
                                sx={{ ...FONT("cormorant", 20, 700) }}
                                onClick={() => {
                                    if (menu.title === "Rooms")
                                        onNavigate({ path: `rooms/${navigation?.roomList[0].roomIdx}` });
                                    if (menu.title === "Specials")
                                        onNavigate({ path: `specials/${navigation?.specialList[0].specialIdx}` });
                                    if (menu.title === "About") onNavigate({ path: "about" });
                                    if (menu.title === "Guide") onNavigate({ path: "guide" });
                                    if (menu.title === "Reservation") onNavigate({ path: "reserve" });
                                }}
                            >
                                {menu.title}
                            </Text>
                        </Box>
                    );
                })}
            </MotionTitleBox>
            <Button round="pill" onClick={() => window.open(bookingEngine.bookingUrl)}>
                {isMobile ? "예약" : "예약하기"}
            </Button>
        </Center>
    );
};

const MotionTitleBox = chakra(motion.div);
